module.exports = __webpack_public_path__ + "8d0d2841bd68419aeca73b5da77628c7.pdf";